export function addCurrency(amount: number, currency = 'PLN'): string {
  return `${currency} ${amount ? amount : '0'}`;
}
